import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image } from "@chakra-ui/react";
import { TopDisplay } from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo, lazy, Suspense} from "react";
import styled from "@emotion/styled";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import apiCall from "../../../utils/apiCall";
import { useQuery, useQueryClient } from 'react-query';
import ReactPaginate from 'react-paginate';
import { TbReload as ReloadIcon } from "react-icons/tb";
import moment from "moment";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from '@chakra-ui/react'
import {useAtom,atom} from 'jotai'
import { modalAtom, notificationAtom, openAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import ReactSelect from "../../../components/Select";
import appStore,{activePeriod} from "../../../store";

// Lazy-loaded: pulls in html2canvas/jsPDF, only needed once "View Result" is clicked.
const StatementResult = lazy(() => import("./Modal/StatementResult"));

const indexAtom = atom<number | null>(null);
const list = [
  {
    Id:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    Email:'Abey.Adesola@gmail.com',
    Subjects:"Subject1,Subject2",
    StudyCenter:"Yaba",
    LastExam:"HRM1,HRM2",
    RegistrationDate:"03-12-2023",
    Level:'2',
    Amount:'300,000',
    Results:'Pending'
  },
  {
    Id:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    Email:'Abey.Adesola@gmail.com',
    Subjects:"Subject1,Subject2",
    StudyCenter:"Yaba",
    LastExam:"HRM1,HRM2",
    RegistrationDate:"03-12-2023",
    Level:'2',
    Amount:'300,000',
    Results:'Pending'
  },
  {
    Id:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    Email:'Abey.Adesola@gmail.com',
    Subjects:"Subject1,Subject2",
    StudyCenter:"Yaba",
    LastExam:"HRM1,HRM2",
    RegistrationDate:"03-12-2023",
    Level:'2',
    Amount:'300,000',
    Results:'Pending'
  },
  {
    Id:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    Email:'Abey.Adesola@gmail.com',
    Subjects:"Subject1,Subject2",
    StudyCenter:"Yaba",
    LastExam:"HRM1,HRM2",
    RegistrationDate:"03-12-2023",
    Level:'2',
    Amount:'300,000',
    Results:'Pending'
  },
  {
    Id:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    Email:'Abey.Adesola@gmail.com',
    Subjects:"Subject1,Subject2",
    StudyCenter:"Yaba",
    LastExam:"HRM1,HRM2",
    RegistrationDate:"03-12-2023",
    Level:'2',
    Amount:'300,000',
    Results:'Pending'
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  ":nth-of-type(5)":{
    maxWidth:'250px',
    overflow:'hidden'
  },
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function RegisteredCandidate() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const queryClient = useQueryClient();
  const [selected_level,set_selected_level] = useState<null | string>(null);
  const [selected_examperiod,set_selected_examperiod] = useState<string>('');
  const aPeriod:any = appStore.get(activePeriod);
  const {data:allLevel} = useQuery(['exemption'],{
    queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allExamPeriod} = useQuery(['exam-periods'],{
    queryFn:async ()=> await apiCall().get(`/exam/setup/examPeriod`),
    select(data){
      //console.log(data,'exam-period')
      return data.data.Data;
    },
  })

  const [search, set_search] = useState('');
  const [debounced_search, set_debounced_search] = useState('');
  const itemsPerPage = 100;
  const [pageNumber, set_pageNumber] = useState(1);

  // Debounce the search box so typing doesn't fire a request per keystroke.
  useEffect(() => {
    const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  // Any change to filters/search invalidates the current page.
  useEffect(() => {
    set_pageNumber(1);
  }, [selected_examperiod, selected_level, debounced_search]);

  const selectedPeriodName = useMemo(() => {
    if (!selected_examperiod) return null;
    return (allExamPeriod || []).find((p: any) => String(p.Id) === String(selected_examperiod))?.ExamName ?? null;
  }, [allExamPeriod, selected_examperiod]);

  // One request per page, always - server applies PageNumber/PageSize plus
  // whichever filters are active. ExamPeriodId/LevelId aren't 100% reliably
  // honored by this endpoint, so as a cheap (no extra request) safety net we
  // also re-check the real Level.Id/ExamPeriod fields on just the page that
  // came back, instead of pre-fetching every page up front.
  const { data: pagedResult, isLoading } = useQuery(
    ['registration-report-page', selected_examperiod, selected_level, debounced_search, pageNumber],
    async () => {
      const params: Record<string, any> = {
        PageNumber: pageNumber,
        PageSize: itemsPerPage,
      };
      if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
      if (selected_level) params.LevelId = selected_level;
      if (debounced_search) params.StudentNo = debounced_search;

      const response = await apiCall().get(`Exam/GetAllRegisteredStudent`, { params });
      return response.data;
    },
    {
      keepPreviousData: true,
      select(data: any) {
        let items = data?.reportItems || [];
        if (selected_level) items = items.filter((d: any) => String(d.Level?.Id) === String(selected_level));
        if (selectedPeriodName) items = items.filter((d: any) => d.ExamPeriod === selectedPeriodName);
        const totalCount = data?.TotalCount ?? items.length;
        return {
          items,
          totalCount,
          pageCount: data?.PageCount ?? Math.max(1, Math.ceil(totalCount / itemsPerPage)),
        };
      },
    }
  );

  const currentItems = pagedResult?.items || [];
  const totalCount = pagedResult?.totalCount ?? 0;
  const pageCount = pagedResult?.pageCount ?? 1;
  const itemOffset = (pageNumber - 1) * itemsPerPage;
  const endOffset = Math.min(itemOffset + itemsPerPage, totalCount);

  const handlePageClick = (event: any) => {
    set_pageNumber(event.selected + 1);
  };

  const examPeriodIdByName = useMemo(() => {
    const map = new Map<string, any>();
    (allExamPeriod || []).forEach((p: any) => map.set(p.ExamName, p.Id));
    return map;
  }, [allExamPeriod]);

  return (
    <>
      {isLoading?<Loader />:
        <Box>
        <TopDisplay label="Select & View Student Result In Option" button_array={[
            // <Button leftIcon={<DownloadIcon/>} variant="outline"
            //   colorScheme="var(--dark-green-color)"
            // >Download Candidates</Button>,
            // <UploadButton label="Upload Candidates" />
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
             <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
                <InputLeftElement pointerEvents='none'>
                  <SearchIcon color='gray.300' />
                </InputLeftElement>
                <Input
                  value={search}
                  onChange={(e: any) => set_search(e.target.value)}
                  type='text'
                  placeholder='StudentNo '
                  bg="var(--white-color)"
                  borderColor="var(dark-green-color)"
                />
                <span
                  style={{
                    position: 'absolute',
                    zIndex: '1',
                    right: '10px',
                    cursor: 'pointer',
                    top: '12px',
                  }}
                  onClick={() => {
                    set_search("");
                  }}>
                  <ReloadIcon />
                </span>
              </InputGroup>
             <ReactSelect
              name="ExamName"
              onChange={(value: any) => set_selected_examperiod(value?.Id ? value.Id.toString() : '')}
              placeholder="Exam Period"
              options={allExamPeriod?.map((e: any) => ({ ...e, ['label']: e.ExamName, ['value']: e.Id }))}
            />
            <Select placeholder="Level" width="140px" bg="var(--white-color)"
              borderColor="var(dark-green-color)" onChange={(e: any) => set_selected_level(e.target.value || null)} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Candidates</Heading>
            <Text m="0" fontSize=".8rem">showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}</Text>
          </Flex>
      {currentItems && currentItems.length > 0 ? (
  <TableContainer mt="20px">
    <Table size='sm'>
      <Thead>
        <Tr>
          <Th sx={HeadStyle}>StudentNo</Th>
          <Th sx={HeadStyle}>First Name</Th>
          <Th sx={HeadStyle}>Last Name</Th>
          <Th sx={HeadStyle}>Phone</Th>
          <Th sx={HeadStyle}>Email</Th>
          <Th sx={HeadStyle}>Subjects</Th>
          {/* <Th sx={HeadStyle}>Study Cent.</Th> */}
          <Th sx={HeadStyle}>Last Exam</Th>
          <Th sx={HeadStyle}>Level</Th>
          <Th sx={HeadStyle}>ExamPeriod</Th>
          {/* <Th sx={HeadStyle}>Amount</Th> */}
          <Th sx={HeadStyle}>Reg.Date</Th>
          {/* <Th sx={HeadStyle}>Resit</Th> */}
          <Th sx={HeadStyle} w="50px"></Th>
        </Tr>
      </Thead>
      <Tbody>
      {currentItems && currentItems.length > 0 ? (
  currentItems.map((eCandidate: any, index: number) => {
    // Check if eCandidate is defined
    if (!eCandidate) {
      console.warn(`eCandidate at index ${index} is undefined`);
      return null; // Skip this iteration if eCandidate is undefined
    }

    return (
      <ROWSTYLE key={eCandidate.SN}>
        <Td sx={DataStyle}>{eCandidate?.StudentNo}</Td>
        <Td sx={DataStyle}>{eCandidate?.FirstName}</Td>
        <Td sx={DataStyle}>{eCandidate?.LastName}</Td>
        <Td sx={DataStyle}>{eCandidate?.PhoneNumber || 'N/A'}</Td>
        <Td sx={DataStyle}>{eCandidate?.Email || 'N/A'}</Td>
        <Td sx={DataStyle}>
          {eCandidate?.Subjects?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(',')?.length > 35
            ? eCandidate?.Subjects?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(',').slice(0, 31) + ' ...'
            : eCandidate?.Subjects?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(',') || 'N/A'}
        </Td>
        {/* <Td sx={DataStyle}>{eCandidate?.StudyCenter?.Name || 'N/A'}</Td> */}
        <Td sx={DataStyle}>
          {eCandidate?.LastExam?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(',')?.length > 35
            ? eCandidate?.LastExam?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(',').slice(0, 31) + ' ...'
            : eCandidate?.LastExam?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(',') || 'N/A'}
        </Td>
        <Td sx={DataStyle}>{eCandidate?.Level ? eCandidate.Level.ExemptionName : 'N/A'}</Td>
        <Td sx={DataStyle}>{eCandidate?.ExamPeriod || 'N/A'}</Td>
        {/* <Td sx={DataStyle}>{eCandidate?.Amount || 'N/A'}</Td> */}
        <Td sx={DataStyle}>{eCandidate?.RegistrationDate ? moment(eCandidate.RegistrationDate).format("YYYY-MM-DD") : 'N/A'}</Td>
        {/* <Td sx={DataStyle}>{eCandidate?.IsResit ? 'Yes' : 'No'}</Td> */}
        <Td sx={DataStyle} minW="60px" w="50px" h="50px">
          <div className={activeIndex === index ? 'active' : ''}>
            <Option
              {...{
                index,
                candidate: {
                  ...eCandidate,
                  ExamPeriodId: examPeriodIdByName.get(eCandidate.ExamPeriod)
                },
                levels: allLevel,
                periods: allExamPeriod
              }}
            />
          </div>
        </Td>
      </ROWSTYLE>
    );
  })
) : (
  <Text>No candidates available.</Text>
)}
      </Tbody>
    </Table>
  </TableContainer>
) : (
  search ? (
    <Box textAlign="center" color="red" mt={4}>
      Student not found
    </Box>
  ) : (
    <Text>No Candidate</Text>
  )
)}
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

      </Box>
      }
    </>
    
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
  const queryClient = useQueryClient();

  useEffect(()=>{
    set_new_level(candidate?.Level?.Id)
  },[])

  // const {mutate:updateLevel,isLoading:isLoadingUpdate} = useMutation({
  //   mutationFn: async () => await apiCall().post('/Exam/changeExamLevel',{
  //     StudentMembershipNo:candidate.Subjects.at(-1).StudentNo,
  //     NewLevelId:new_level
  //   }),
  //   onSuccess(data:any){
  //     set_notification({
  //       type:'success',
  //       message:data.data.Message || 'Level Updated Successfully'
  //     })
  //     set_N_open(true);
  //     queryClient.invalidateQueries({
  //       queryKey:['registered-student']
  //     })
  //   },
  //   onSettled(){
  //     set_open(false);
  //   },
  //   onError(error:any){
  //     set_notification({
  //       type:'error',
  //       message:error.data.Message || 'Error Occured'
  //     })
  //     set_N_open(true);
  //   }
  // })

  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

  const handleViewResult = () =>{
    set_index(null);
    set_modal({
      header:'Statement of Result',
      content:(
        <Suspense fallback={<Loader />}>
          <StatementResult data={candidate} periods={props?.periods} levels={props?.levels} />
        </Suspense>
      )
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          <GridItem sx={sx} p="8px 4px" onClick={handleViewResult}>View Result</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Flex align="center" gap="20px">
    <Image
        src={props?.candidate.ImageUrl ? props?.candidate.ImageUrl:img}
        width="150px"
        height="150px"
        borderRadius="50px"
        objectFit="cover"
        objectPosition="center"
        alt="profile.png"
      />
        {/* < img src={props?.candidate.ImageUrl ? props?.candidate.ImageUrl:img}
       style={{objectFit:"contain",width:"150px",borderRadius:"10px",objectPosition:"center"}}
      /> */}
      <Flex flexDir="column">
        <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading>
        <Text>Student</Text>
        <Text>ID: {props.candidate.Subjects.at(0).StudentNo}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="repeat(3,1fr)"  gap="30px">
      
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Level</Text>
        <Text fontWeight="500">{props.candidate?.Level?.ExemptionName}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Subjects</Text>
        <Text fontWeight="500">
          {props.candidate.Subjects.map((eSubject:any)=> eSubject.ExamSubject.Name)}
        </Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Amount Paid</Text>
        <Text fontWeight="500"># {props.candidate.Amount}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Study Center</Text>
        <Text fontWeight="500">{props.candidate.StudyCenter || 'Study Center 1'}</Text>
      </GridItem>
      <GridItem>
      <Text fontWeight="500" color="var(--light-text)"> Registration Date</Text>
      <Text fontWeight="500">{moment(props.candidate.RegistrationDate).format("yyyy-MM-DD")}</Text>
    </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
        <Text fontWeight="500">{props.candidate.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
        <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate.Address}</Text>
      </GridItem>
      {/* <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Exam Status</Text>
        <Text fontWeight="500">{props.candidate.ExamStatus}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Payment Status</Text>
        <Text fontWeight="500">{props.candidate.ExamPaymentStatus}</Text>
      </GridItem> */}
      
      
    </Grid>
  </Flex>
  )}
 


  
